module.exports = __webpack_public_path__ + "resources/images/triodos_bank-2abb6001f853e3808e11cdf91d29eae1-cache.png";